<template>
    <section>
        <v-card>
            <v-card-title class="text-h6">
                Ajouter un podcast
            </v-card-title>
            <v-row style="margin: 20px">
                <v-col cols="12" sm="12" md="12">
                    <v-autocomplete v-model="selectedCategory" clearable label="Catégorie" :items="categories" item-text="label"
                        item-value="id" outlined @change="fetchSubCategories"></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                    <v-autocomplete v-model="SubCategoriesSelected" clearable label="Sous-catégorie" :items="SubCategories" item-text="label"
                        item-value="id" outlined @change="getAllDossier"></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                    <v-autocomplete v-model="dossier" clearable label="dossier" :items="dossierArray" item-text="title"
                        item-value="id" outlined @change="onDossierChange"></v-autocomplete>
                </v-col>
                <!--
                <v-col cols="6" sm="6" ms="6">
                    <v-text-field v-model="name" label="Nom du podcast"></v-text-field>
                </v-col>
                <v-col cols="6" sm="6" ms="6">
                    <v-text-field v-model="nameEn" label="Nom du podcast (en)"></v-text-field>
                </v-col>
                  <v-row >
                <v-col cols="6" sm="6" md="4" >
                  <vue-upload-multiple-image style="margin-left: 160px" v-model="images_BG" :data-images="images_BG"
                    accept="image/*	" name="images" drag-text="Veuillez ajouter une image Sans arrière-plan"
                    browse-text="Browse image" primary-text="Image" mark-is-primary-text="Set default image"
                    :min-image="1" :multiple="false" :showEdit="false" popup-text="Description default image"
                    drop-text="Drag and drop" @upload-success="uploadImageSuccess" @before-remove="beforeRemove_BG"
                    :idUpload="images_BGId">
                  </vue-upload-multiple-image>
                  <v-progress-linear v-if="showlowding_BG && uploadPercentage_BG < 100"
                    style="max-width: 190px; margin-left: 160px" color="primary" indeterminate rounded
                    height="15"><strong>{{ Math.ceil(uploadPercentage_BG) }}%</strong></v-progress-linear>
                </v-col>
            </v-row>
-->
                <v-col cols="6" sm="6" md="6">
                    <label>Audio File
                        <input type="file" accept="audio/*" @change="handleAudioUpload($event)" />
                        <v-progress-linear v-if="showlowding_audio" style="max-width: 300px; margin-top: 10px"
                            color="primary" indeterminate rounded height="6"></v-progress-linear>
                    </label>
                </v-col>
            </v-row>
            <v-row align="center" style="margin: 20px" v-show="echec">
                <v-col cols="6" sm="6" md="6"></v-col>
                <v-col cols="6" sm="6" md="6">
                    <span style="color: red">Échec d'upload du fichier audio</span>
                </v-col>
            </v-row>
            <v-row align="center" style="margin: 20px" v-if="audioUrl">
                <v-col cols="6" sm="6" md="6">
                    <v-col>Fichier audio :</v-col>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                    <vuetify-audio style="height: 100px; margin-top: 10px; margin-bottom: 10px" :file="audioUrl"
                        :autoPlay="false" :flat="false" :playIcon="icons.mdiPlay" :pauseIcon="icons.mdiPause"
                        :stopIcon="icons.mdiStop" :refreshIcon="icons.mdiRefresh" :volumeHighIcon="icons.mdiVolumeHigh"
                        :volumeMuteIcon="icons.mdiVolumeMute"></vuetify-audio>
                </v-col>
            </v-row>


            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn :disabled="dossier === null || audioUrl === null" color="info darken-1 " @click="ajoutPodcast()"
                    text>
                    Confirmer
                </v-btn>
            </v-card-actions>
        </v-card>

        <v-card class="mb-6 ml-6 mt-6 mr-2">
            <v-card-title>Liste des podcasts</v-card-title>
            <v-text-field style="padding: 15px" v-model="search" append-icon="mdi-magnify" label="Search" single-line
                hide-details clearable :search="search"></v-text-field>
            <v-data-table :search="search" :loading="isLoadingTables" loading-text="Loading..." :footer-props="{
                'items-per-page-options': [5, 10, 15, 30],
            }" :headers="headers" :items="podcastArray" class="elevation-1" item-key="id">
            
        <template v-slot:[`item.imgUrl`]="{ item }">
          <v-img
            v-if="item.imgDBType !== 'svg'"
            :src="item.imgUrl"
            width="65"
            height="65"
          />
          <div
            v-if="item.imgDBType === 'svg'"
            v-html="item.svgContent"
          ></div>

          <v-divider></v-divider>
        </template>
                <template v-slot:[`item.name`]="{ item }">
                    {{ item.name }}
                </template>
                <template v-slot:[`item.actualityTitle`]="{ item }">
                    {{ item.actualityTitle }}
                </template>
                <template v-slot:[`item.fileUrl`]="{ item }">
                    <vuetify-audio style="height: 150px; margin-top: 10px; margin-bottom: 10px" :file="item.fileUrl"
                        :autoPlay="false" :flat="false" :playIcon="icons.mdiPlay" :pauseIcon="icons.mdiPause"
                        :stopIcon="icons.mdiStop" :refreshIcon="icons.mdiRefresh" :volumeHighIcon="icons.mdiVolumeHigh"
                        :volumeMuteIcon="icons.mdiVolumeMute"></vuetify-audio>
                </template>

                <template v-slot:[`item.modifier`]="{ item }">
                    <v-icon @click="editPodcast(item)">
                        {{ icons.mdiPencil }}
                    </v-icon>
                </template>
                <template v-slot:[`item.supprimer`]="{ item }">
                    <v-icon @click="deletePodcast(item)">
                        {{ icons.mdiDeleteOutline }}
                    </v-icon>
                </template>
            </v-data-table>
        </v-card>

    </section>
</template>

<script>
import { VuetifyAudio } from "vuetify-audio";
import VueUploadMultipleImage from "vue-upload-multiple-image";
import store from "@/store/image";
import constants from '@/utils/constants';
import { getActualityByCategory, getAllActualityCategory ,FetchSubCategoryById, FetchAllSubCategoriesByCategoryId, FetchActualityByCategoryAndSubCategory} from '@/views/qorani/services/services';
import axios from 'axios';
import { mdiPlay, mdiPause, mdiStop, mdiRefresh, mdiDownload, mdiVolumeHigh, mdiVolumeMute, mdiPencil, mdiDeleteOutline } from '@mdi/js';

export default {
  components: { VueUploadMultipleImage, VuetifyAudio },

    data() {
        return {
            categories: [],
            selectedCategory: null,
            SubCategories: [],
            SubCategoriesSelected: null,
            name: "",
            nameEn: "",
            dossier: null,
            fileId: null,
            imgDBUrlId:null,
            audioUrl: null,
            showlowding_audio: false,
            echec: false,
            search: "",
            isLoadingTables: false,
            dossierArray: [],
            podcastArray: [],
            images_BG: [],
            showlowding_BG: false,
            uploadPercentage_BG: null,
            images_BGId: "1",
            icons: {
                mdiPlay,
                mdiPause,
                mdiStop,
                mdiRefresh,
                mdiDownload,
                mdiVolumeHigh,
                mdiVolumeMute,
                mdiPencil,
                mdiDeleteOutline
            },
            headers: [
                        { text: "Image", value: "imgUrl" },

                { text: "Nom", value: "name", align: "center" },
                { text: "Dossier", value: "actualityTitle", align: "center" },
                { text: "Audio", value: "fileUrl", align: "center" },
                { text: "Modifier", value: "modifier", align: "center" },
                { text: "Supprimer", value: "supprimer", align: "center" },

            ]
        };
    },
    methods: {
        async fetchSubCategories() {
            this.isLoadingTables = true;
            this.SubCategories = await FetchAllSubCategoriesByCategoryId(this.selectedCategory);
            this.isLoadingTables = false;
        },
    async fetchCategories() {
            this.isLoadingTables = true;
            this.categories = await getAllActualityCategory();
            this.isLoadingTables = false;
        },
        async loadImage(item) {
            const imgId = item.imgDBId;
            const imgType = item.imgDBType;
            if (!imgId) return;

            if (imgType === "svg") {
                try {
                    const response = await fetch(
                        `${constants.QORANI}fileDB/files/${imgId}`
                    );
                    if (!response.ok)
                        throw new Error("Échec du chargement de l'image SVG");

                    let svgContent = await response.text();

                    // Ajoute width et height directement dans le SVG
                    svgContent = svgContent
                        .replace(/(<svg[^>]*)\swidth="[^"]*"/i, "$1")
                        .replace(/(<svg[^>]*)\sheight="[^"]*"/i, "$1")
                        .replace(/(<svg[^>]*)>/i, '$1 width="65" height="65">');

                    this.$set(item, 'svgContent', svgContent);
                } catch (error) {
                    console.error("Erreur lors du chargement de l'image :", error);
                }
            } else {
                this.$set(item, 'imgUrl', `${constants.QORANI}fileDB/files/${imgId}`);
            }
        },
        onDossierChange() {
            console.log("Selected dossier ID:", this.dossier);
            const { title = "", titleEn = "" } = this.dossierArray.find(d => d.actualityCategory.id === this.dossier) || {};
            this.name = title;
            this.nameEn = titleEn;
        },
        async getAllPodcast() {
            try {
                this.isLoadingTables = true;
                const response = await axios.get(`${constants.QORANI}podcast/getall`);
                console.log(response.data);
                // Enrichir les podcasts avec le nom du dossier
                this.podcastArray = response.data.map(podcast => ({
                    ...podcast,
                    actualityTitle: this.dossierArray.find(d => d.id === podcast.actualityId)?.title || "N/A"
                }));
                this.podcastArray.forEach(async (item) => {
                    if (item.imgDBId ) {
                        await this.loadImage(item);
                    }
                });
                this.isLoadingTables = false;
                return this.podcastArray;
            } catch (error) {
                console.error("Error fetching podcasts:", error);
                this.isLoadingTables = false;
                return [];
            }
        },
        async getAllDossier() {
            try {
                const CategorySelected = this.categories.find(cat => cat.id === this.selectedCategory).category;
                const SubCategorySelected = this.SubCategoriesSelected;
                const response = await FetchActualityByCategoryAndSubCategory(CategorySelected, SubCategorySelected);
                this.dossierArray = response;
                console.log("test"+response);
                
                return response;
            } catch (error) {
                console.error("Error fetching dossiers:", error);
                return [];
            }
        },
        handleAudioUpload(event) {
            this.echec = false;
            this.snackbar = false;

            this.showlowding_audio = true;
            
            const apiEndpoint = `${constants.QORANI}files/uploadABSPodcast`;
            const folderId = "c43816a1-cc90-48fd-b855-25ddbf57bb78";
            const libraryId = "6b9fc4e1-f445-47f8-95fc-69a97d3dba85";
            const title =  this.dossierArray.find(d => d.id === this.dossier)?.title + '_' + Date.now();
            const file = event.target.files[event.target.files.length - 1];
            const customFormData = new FormData();
            customFormData.append("file", file);
            customFormData.append("folder", folderId);
            customFormData.append("library", libraryId);
            customFormData.append("title", title);
            customFormData.append("fromPostman", false);

            axios
                .post(apiEndpoint, customFormData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then((response) => {
                    if (response.data.id) {
                        console.log("Audio upload success:", response.data);
                        this.fileId = response.data.id;
                        this.audioUrl = response.data.downloadAudioBookUrl || "";
                        this.showlowding_audio = false;
                        event.target.value = null;
                    } else {
                        this.fileId = response.data.id;
                        this.snackbar = true;
                        this.audioUrl = response.data.downloadAudioBookUrl || "";
                        this.showlowding_audio = false;
                        this.echec = true;
                        event.target.value = null;
                    }
                })
                .catch((error) => {
                    console.error("Error uploading audio:", error);
                    this.showlowding_audio = false;
                });
        },
        async ajoutPodcast() {
            try {
                const payload = {
                    actualityId: this.dossier,
                    fileId: this.fileId,
                };
                try {
                    let res = await axios.post(`${constants.QORANI}podcast/add`, payload);
                    if (res.data.id) {
                        this.name = "";
                        this.nameEn = "";
                        this.dossier = null;
                        this.fileId = null;
                        this.imgDBUrlId = null;
                        await this.getAllPodcast();
                    }
                } catch (error) {
                    alert(
                        "Une erreur est survenue lors de la création du podcast, veuillez réessayez plus tard, Merci."
                    );
                }

            } catch (error) {
                console.error("Error adding podcast:", error);
            }
        },
        editPodcast(item) {
            console.log("Edit podcast:", item);
            this.$router.push(`/EditPodcast/${item.id}`);
        },
        async deletePodcast(item) {
            try {
                await axios.get(`${constants.QORANI}podcast/delete/${item.id}`);
                await this.getAllPodcast();
                console.log("Podcast supprimé");
            } catch (error) {
                console.error("Error deleting podcast:", error);
            }
        },
        handleImagesUpdated_BG(images_BG) {
            const uploadedImage = images_BG[0];
            console.log("Uploaded image:", uploadedImage);
    },
        async uploadImageSuccess(formData, index, fileList) {
            try {
                await store.dispatch("uploadImageSuccess", {
                formData,
                index,
                fileList,
                });
                this.imageId = store.state.imageId;

                const imageId = store.state.imageId;

            this.imgDBUrlId = imageId;

                console.log("Image id :", imageId);
            } catch (error) {
                console.error("Failed to upload image:", error);
            }
        },
        beforeRemove_BG(index, done, fileList) {
            this.showlowding_BG = false;
            this.fakePercentage_BG = 0;
            this.uploadPercentage_BG = 0;
            const r = confirm("remove image");
            if (r === true) {
                const indexInArrayImages = this.imagesUpload_BG.indexOf(
                fileList[index].path
                );
                this.imageUrl_BG = "";
                this.imageId_BG = "";
                if (index > -1) {
                this.imagesUpload_BG.splice(indexInArrayImages, 1);
                }

                done();
            }
        },


    },
    async created() {
        await this.fetchCategories();
        //await this.getAllDossier();
        await this.getAllPodcast();
    }

}
</script>

<style></style>